import { Helmet } from "react-helmet";

const BASE_URL = "https://www.rsjc.co.uk";

function Canonical() {
  let path = window.location.pathname;

  // Remove trailing slash (except root)
  if (path !== "/") {
    path = path.replace(/\/$/, "");
  }

  const url = `${BASE_URL}${path === "/" ? "" : path}`;

  return (
    <Helmet>
      <link rel="canonical" href={url} />
    </Helmet>
  );
}

export default Canonical;
